/**
 * FR-11.9. On iOS, Safari clears a site's storage — IndexedDB, the service
 * worker and its caches alike — after seven days without a visit. A sauna
 * heated monthly falls outside that window every time.
 *
 * Losing the cached data would not matter; it is all in Supabase. What
 * cannot be refetched is the app itself, at a sauna with no signal. Adding
 * it to the home screen exempts it from the cap, so installation is what
 * makes the offline promise true — not a nicety to suggest in a banner.
 */
export type Platform = "ios" | "android" | "desktop";

export function platform(): Platform {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "ios";
  if (/Android/.test(ua)) return "android";
  return "desktop";
}

export function isInstalled(): boolean {
  return matchMedia("(display-mode: standalone)").matches ||
    ("standalone" in navigator && (navigator as { standalone?: boolean }).standalone === true);
}

/** True when this device cannot be trusted to still have the app next month. */
export function needsInstallForOffline(): boolean {
  return platform() === "ios" && !isInstalled();
}
